import { Grid } from '@mui/material';
import { TemplateCardItem } from './TemplateCardItem';

export const TemplateCards = ({ templates = [], selectedTemplate = null, onClick = () => {} }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      {templates.map((template, index) => (
        <TemplateCardItem
          key={index}
          template={template}
          isSelected={template?.id === selectedTemplate?.id}
          onClick={onClick}
        />
      ))}
    </Grid>
  );
};
